<template>
  <b-overlay
    id="overlay-background"
    :show="emailSettingLoader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <validation-observer
              ref="refEmailTemplate"
            >
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Actions"
                      rules="required"
                    >
                      <b-form-group
                        label="Actions"
                        label-for="Actions"
                      >
                        <v-select
                          v-model="actionSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="actionsOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          @input="getActionTemplate"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                      #default="{ errors }"
                      name="Email Template"
                      rules="required"
                    >
                      <b-form-group
                        label="Email template"
                        label-for="Email Template"
                      >
                        <v-select
                          v-model="templateSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="templateOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  variant="primary"
                  @click="postTemplates"
                >
                  Save
                </b-button>
              </b-form>
            </validation-observer>
          <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
// import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      emailSettingLoader: false,
      selected: {
        label: '',
        value: '',
      },
      templateSelected: 0,
      templateOptions: [],
      actionsOptions: [],
      actionSelected: '',
      actions: '',
      defaultAction: '',
      template: '',
      action_id: '',
      template_id: '',
    }
  },
  watch: {
    settings: {
      handler() {
        this.communication_client_id = this.settings.client_id
        this.communication_secret = this.settings.secret
        this.getTemplate()
      },
    },
    actionSelected: {
      handler(newValue) {
        this.getActionTemplate(newValue)
      },
    },
  },
  created() {
    this.getActions()
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.emailSettingLoader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    async getTemplate() {
      // const headers = {
      //   clientId: this.communication_client_id,
      //   secret: this.communication_secret,
      // }
      // await axiosemail.get('/v1/email/get-templates', { headers }).then(settings => {
      //   if (settings.status) {
      //     this.template = settings.data.data
      //     for (let i = 0; i < this.template.length; i += 1) {
      //       const obj = {
      //         label: this.template[i].name,
      //         value: this.template[i].id,
      //       }
      //       this.templateOptions.push(obj)
      //     }
      //   }
      // }).catch(error => {
      //   this.makeFailureToast(error)
      // })
    },
    async getActions() {
      await axios.get('/settings/get-default-actions-dropdown').then(actions => {
        if (actions.status) {
          this.actions = actions.data.data
          this.actionSelected = this.actions[0].value
          this.getActionTemplate(this.actionSelected)
          for (let i = 0; i < this.actions.length; i += 1) {
            const obj = this.actions[i]
            this.actionsOptions.push(obj)
          }
        }
      }).catch(error => {
        this.makeFailureToast(error)
      })
    },

    async getActionTemplate(actionId) {
      this.emailSettingLoader = true
      await axios.get(`/settings/get-default-action-template?action_id=${actionId}`).then(template => {
        if (template.status) {
          this.templateSelected = template.data.data && template.data.data.template_id !== 0 ? template.data.data.template_id : ''
          this.emailSettingLoader = false
        }
      }).catch(error => {
        this.makeFailureToast(error)
      })
    },

    postTemplates() {
      this.$refs.refEmailTemplate.validate().then(success => {
        if (success) {
          this.emailSettingLoader = true
          axios.post('/settings/save-default-action-template', {
            action_id: this.actionSelected,
            template_id: this.templateSelected,
          }).then(response => {
            if (response.status) {
              this.emailSettingLoader = false
              this.makeSuccessToast()
            }
          }).catch(error => {
            this.makeFailureToast(error)
          })
        }
      })
    },
  },
}

</script>
